import React, {Component} from "react"
import styles from "./CheckBox.module.css"
import {JsonDocument} from "Model"

interface Props {
    label: string
    id: string
    value: string
    json_data: JsonDocument
    onChange: (id, value) => void
}

export class CheckBox extends Component<Props, {}> {
    public render() {
        const {id, value, json_data, onChange, label} = this.props
        let checked: boolean = json_data[id] === "yes"
        return (
            <label className={styles.root} htmlFor={id}>
                <input
                    type="checkbox"
                    id={id}
                    value={value}
                    checked={checked}
                    onChange={(event) => {
                        let value: "yes" | "no" = "no"
                        if (event.target.checked) {
                            value = "yes"
                        }
                        onChange(id, value)
                    }}
                />
                <p className={`${styles.text}`}>{label}</p>
            </label>
        )
    }
}
